/**
 * Sección "Equipo" — gestión de usuarios staff y sus permisos.
 * Carlos crea cuentas con acceso limitado a secciones específicas del dashboard.
 */
import { apiClient, toast } from './_common.js';

function escapeHtml(s) {
  return String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}

// Wrapper que normaliza la firma: api(path, {method, body})
async function api(path, opts = {}) {
  const method = (opts.method || 'GET').toUpperCase();
  const body = opts.body ? JSON.parse(opts.body) : undefined;
  const fn = apiClient[method.toLowerCase()];
  if (!fn) throw new Error('método no soportado: ' + method);
  return method === 'GET' || method === 'DELETE' ? fn(path) : fn(path, body);
}

// Catálogo de secciones a las que se puede dar permiso.
// key = identificador interno; label = nombre visible
const SECTIONS = [
  { key: 'autosell_leads', label: 'Leads Autosell (tasaciones web)' },
  { key: 'autosell', label: 'Autosell (stock vehículos)' },
  { key: 'inmuebles', label: 'Inmuebles' },
  { key: 'marketplace', label: 'Marketplace (Wallapop, etc.)' },
  { key: 'agency', label: 'Agency (lead-gen)' },
  { key: 'meta_ads', label: 'Meta Ads' },
  { key: 'patrimonio', label: 'Patrimonio' },
  { key: 'tareas', label: 'Tareas' },
  { key: 'notas', label: 'Notas' },
  { key: 'archivos', label: 'Archivos' },
  { key: 'chat', label: 'Chat IA' },
];

export function renderEquipo(root, ctx) {
  root.innerHTML = `
    <div class="page">
      <div class="page-head" style="display:flex;justify-content:space-between;align-items:center;margin-bottom:18px;flex-wrap:wrap;gap:10px">
        <div>
          <h1 style="font-size:24px;font-weight:800;color:#EAB546">👥 Equipo</h1>
          <p style="color:#9A9384;font-size:13px;margin-top:4px">Crea cuentas para tus trabajadores con acceso limitado</p>
        </div>
        <button id="btn-new-staff" class="btn-primary" style="padding:10px 18px;background:linear-gradient(135deg,#EAB546,#C68618);color:#0C0B09;border:none;border-radius:10px;font-weight:700;cursor:pointer">+ Crear usuario</button>
      </div>

      <div id="staff-info" style="background:rgba(59,130,246,.08);border:1px solid rgba(59,130,246,.3);color:#93c5fd;padding:12px 14px;border-radius:10px;margin-bottom:16px;font-size:13px;line-height:1.5">
        🔗 Tus trabajadores entran a <a href="https://carlos-os1.duckdns.org/equipo/" target="_blank" style="color:#EAB546;font-weight:600">carlos-os1.duckdns.org/equipo/</a> con su usuario y contraseña. Ven solo las secciones que tú elijas aquí.
      </div>

      <div id="staff-list" class="staff-grid" style="display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:14px"></div>
    </div>

    <div id="staff-modal" style="display:none;position:fixed;inset:0;background:rgba(0,0,0,.7);z-index:1000;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(8px)">
      <div style="background:#141210;border:1px solid #1C1916;border-radius:16px;max-width:480px;width:100%;padding:24px;max-height:90vh;overflow-y:auto">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:18px">
          <h3 id="modal-title" style="color:#EAB546;font-size:18px">Nuevo usuario</h3>
          <button id="modal-close" style="background:transparent;border:none;color:#9A9384;font-size:22px;cursor:pointer">×</button>
        </div>
        <div id="modal-err" style="display:none;background:rgba(239,68,68,.1);border:1px solid rgba(239,68,68,.4);color:#fca5a5;padding:10px;border-radius:8px;margin-bottom:14px;font-size:13px"></div>

        <label class="lbl">Usuario *</label>
        <input id="f-username" type="text" placeholder="ej: maria.lopez" class="modal-input">

        <label class="lbl">Nombre completo</label>
        <input id="f-fullname" type="text" placeholder="ej: María López" class="modal-input">

        <label class="lbl">Email</label>
        <input id="f-email" type="email" placeholder="ej: maria@autosell.es" class="modal-input">

        <label class="lbl" id="lbl-pwd">Contraseña *</label>
        <input id="f-password" type="text" placeholder="mínimo 6 caracteres" class="modal-input">

        <label class="lbl">Notas internas (no la ve el usuario)</label>
        <textarea id="f-notes" placeholder="ej: gestiona Autosell, turno mañana" class="modal-input" rows="2"></textarea>

        <div style="margin-top:16px;margin-bottom:8px;padding-top:14px;border-top:1px solid #1C1916">
          <div style="font-weight:700;color:#EAB546;margin-bottom:6px">Permisos por sección</div>
          <div style="font-size:12px;color:#9A9384;margin-bottom:10px">Marca lo que puede ver. "Editar" = puede cambiar datos. "Ver" = solo lectura.</div>
        </div>

        <div id="perms-grid"></div>

        <div style="display:flex;gap:8px;margin-top:18px">
          <button id="modal-cancel" style="flex:1;background:#1C1916;color:#F4F2EE;border:none;padding:11px;border-radius:8px;cursor:pointer;font-weight:600">Cancelar</button>
          <button id="modal-save" style="flex:2;background:linear-gradient(135deg,#EAB546,#C68618);color:#0C0B09;border:none;padding:11px;border-radius:8px;cursor:pointer;font-weight:700">Guardar</button>
        </div>
      </div>
    </div>

    <style>
      .lbl{display:block;font-size:11px;color:#9A9384;text-transform:uppercase;letter-spacing:1px;margin-bottom:5px;margin-top:10px}
      .modal-input{width:100%;background:#0C0B09;border:1px solid #1C1916;color:#F4F2EE;padding:10px 12px;border-radius:8px;font-size:14px;outline:none;font-family:inherit}
      .modal-input:focus{border-color:#EAB546}
      .perm-row{display:flex;justify-content:space-between;align-items:center;padding:8px 0;border-bottom:1px solid #1C1916}
      .perm-row:last-child{border-bottom:none}
      .perm-label{font-size:13px;color:#F4F2EE;flex:1}
      .perm-toggle{display:flex;gap:8px;font-size:11px;color:#9A9384}
      .perm-toggle label{display:flex;align-items:center;gap:4px;cursor:pointer}
      .perm-toggle input[type=checkbox]{width:16px;height:16px;cursor:pointer}
      .staff-card{background:#141210;border:1px solid #1C1916;border-radius:14px;padding:16px;transition:border-color .2s}
      .staff-card:hover{border-color:rgba(234,181,70,.3)}
      .staff-card.inactive{opacity:.5}
      .badge{display:inline-block;padding:2px 8px;border-radius:99px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;margin-left:6px}
      .badge-active{background:rgba(74,222,128,.15);color:#86efac}
      .badge-inactive{background:rgba(156,163,175,.15);color:#9ca3af}
      .action-btn{background:transparent;border:1px solid #1C1916;color:#9A9384;padding:6px 12px;border-radius:8px;font-size:12px;cursor:pointer;font-weight:600}
      .action-btn:hover{border-color:#EAB546;color:#EAB546}
      .action-btn.danger:hover{border-color:#ef4444;color:#ef4444}
    </style>
  `;

  // === Estado ===
  let editingUser = null;

  // === Carga inicial ===
  loadUsers();

  async function loadUsers() {
    try {
      const r = await api('/api/v1/staff/users');
      renderUsers(r.users || []);
    } catch (e) {
      document.getElementById('staff-list').innerHTML = `<div style="color:#ef4444">Error: ${escapeHtml(e.message)}</div>`;
    }
  }

  function renderUsers(users) {
    const list = document.getElementById('staff-list');
    if (users.length === 0) {
      list.innerHTML = `<div style="grid-column:1/-1;text-align:center;padding:40px;color:#5C564B"><div style="font-size:42px">👥</div><div style="margin-top:8px">Aún no hay trabajadores. Pulsa "Crear usuario" para añadir uno.</div></div>`;
      return;
    }
    list.innerHTML = users.map(u => {
      const sections = Object.entries(u.permissions || {})
        .filter(([_, p]) => p.read)
        .map(([k, p]) => {
          const s = SECTIONS.find(x => x.key === k);
          const lbl = s ? s.label : k;
          return `<span style="background:rgba(234,181,70,.1);color:#EAB546;padding:2px 8px;border-radius:99px;font-size:11px">${escapeHtml(lbl)}${p.write ? ' ✏️' : ' 👁'}</span>`;
        })
        .join(' ');
      return `<div class="staff-card ${u.isActive ? '' : 'inactive'}">
        <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:10px">
          <div>
            <div style="font-size:16px;font-weight:700;color:#F4F2EE">${escapeHtml(u.fullName || u.username)}</div>
            <div style="font-size:12px;color:#9A9384;margin-top:2px">@${escapeHtml(u.username)}${u.email ? ' · ' + escapeHtml(u.email) : ''}</div>
          </div>
          <span class="badge ${u.isActive ? 'badge-active' : 'badge-inactive'}">${u.isActive ? 'Activo' : 'Inactivo'}</span>
        </div>
        ${sections ? `<div style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:10px">${sections}</div>` : '<div style="font-size:12px;color:#5C564B;margin-bottom:10px">Sin permisos asignados</div>'}
        ${u.notes ? `<div style="font-size:12px;color:#9A9384;margin-bottom:10px;background:rgba(255,255,255,.02);padding:6px 8px;border-radius:6px">📝 ${escapeHtml(u.notes)}</div>` : ''}
        <div style="display:flex;gap:6px;flex-wrap:wrap">
          <button class="action-btn" data-action="edit" data-id="${u.id}">✏️ Editar</button>
          <button class="action-btn" data-action="reset" data-id="${u.id}">🔑 Reset pwd</button>
          <button class="action-btn ${u.isActive ? 'danger' : ''}" data-action="toggle" data-id="${u.id}" data-active="${u.isActive}">${u.isActive ? '⏸ Desactivar' : '▶ Activar'}</button>
          <button class="action-btn danger" data-action="delete" data-id="${u.id}">🗑 Borrar</button>
        </div>
      </div>`;
    }).join('');

    // Bind acciones
    list.querySelectorAll('button[data-action]').forEach(btn => {
      btn.addEventListener('click', () => handleAction(btn.dataset.action, btn.dataset.id, users.find(x => x.id === btn.dataset.id), btn.dataset.active));
    });
  }

  async function handleAction(action, id, user, active) {
    if (action === 'edit') { openModal(user); return; }
    if (action === 'reset') {
      const pwd = prompt('Nueva contraseña para ' + user.username + ':');
      if (!pwd || pwd.length < 6) return;
      try {
        await api('/api/v1/staff/users/' + id + '/reset-password', { method: 'POST', body: JSON.stringify({ newPassword: pwd }) });
        toast('🔑 Contraseña actualizada');
      } catch (e) { toast('❌ ' + e.message); }
      return;
    }
    if (action === 'toggle') {
      const isActive = active === 'true';
      try {
        await api('/api/v1/staff/users/' + id, { method: 'PATCH', body: JSON.stringify({ isActive: !isActive }) });
        toast(isActive ? '⏸ Usuario desactivado' : '▶ Usuario activado');
        loadUsers();
      } catch (e) { toast('❌ ' + e.message); }
      return;
    }
    if (action === 'delete') {
      if (!confirm('¿Borrar usuario "' + user.username + '"? Esta acción no se puede deshacer.')) return;
      try {
        await api('/api/v1/staff/users/' + id, { method: 'DELETE' });
        toast('🗑 Usuario borrado');
        loadUsers();
      } catch (e) { toast('❌ ' + e.message); }
    }
  }

  // === Modal crear/editar ===
  function buildPermsGrid(current = {}) {
    const grid = document.getElementById('perms-grid');
    grid.innerHTML = SECTIONS.map(s => {
      const p = current[s.key] || { read: false, write: false };
      return `<div class="perm-row">
        <div class="perm-label">${escapeHtml(s.label)}</div>
        <div class="perm-toggle">
          <label><input type="checkbox" data-perm="${s.key}" data-mode="read" ${p.read ? 'checked' : ''}> Ver</label>
          <label><input type="checkbox" data-perm="${s.key}" data-mode="write" ${p.write ? 'checked' : ''}> Editar</label>
        </div>
      </div>`;
    }).join('');
    // Si marca "Editar" → también activa "Ver" auto
    grid.querySelectorAll('input[data-mode="write"]').forEach(cb => {
      cb.addEventListener('change', () => {
        if (cb.checked) {
          const readCb = grid.querySelector(`input[data-perm="${cb.dataset.perm}"][data-mode="read"]`);
          if (readCb) readCb.checked = true;
        }
      });
    });
    // Si desmarca "Ver" → también desmarca "Editar"
    grid.querySelectorAll('input[data-mode="read"]').forEach(cb => {
      cb.addEventListener('change', () => {
        if (!cb.checked) {
          const writeCb = grid.querySelector(`input[data-perm="${cb.dataset.perm}"][data-mode="write"]`);
          if (writeCb) writeCb.checked = false;
        }
      });
    });
  }

  function collectPerms() {
    const out = {};
    document.querySelectorAll('#perms-grid input[type=checkbox]').forEach(cb => {
      const key = cb.dataset.perm;
      const mode = cb.dataset.mode;
      if (!out[key]) out[key] = { read: false, write: false };
      if (cb.checked) out[key][mode] = true;
    });
    // Solo guardar las que tengan al menos read=true
    return Object.fromEntries(Object.entries(out).filter(([_, v]) => v.read));
  }

  function openModal(user = null) {
    editingUser = user;
    const modal = document.getElementById('staff-modal');
    modal.style.display = 'flex';
    document.getElementById('modal-err').style.display = 'none';
    document.getElementById('modal-title').textContent = user ? 'Editar usuario · ' + user.username : 'Nuevo usuario';
    document.getElementById('f-username').value = user ? user.username : '';
    document.getElementById('f-username').disabled = !!user;
    document.getElementById('f-fullname').value = user ? (user.fullName || '') : '';
    document.getElementById('f-email').value = user ? (user.email || '') : '';
    document.getElementById('f-password').value = '';
    document.getElementById('f-password').style.display = user ? 'none' : 'block';
    document.getElementById('lbl-pwd').style.display = user ? 'none' : 'block';
    document.getElementById('f-notes').value = user ? (user.notes || '') : '';
    buildPermsGrid(user ? user.permissions : { autosell_leads: { read: true, write: true } });
  }

  function closeModal() {
    document.getElementById('staff-modal').style.display = 'none';
    editingUser = null;
  }

  async function saveUser() {
    const err = document.getElementById('modal-err');
    err.style.display = 'none';
    const username = document.getElementById('f-username').value.trim();
    const fullName = document.getElementById('f-fullname').value.trim();
    const email = document.getElementById('f-email').value.trim();
    const password = document.getElementById('f-password').value;
    const notes = document.getElementById('f-notes').value.trim();
    const permissions = collectPerms();
    try {
      if (editingUser) {
        const body = { fullName, notes, permissions };
        if (email) body.email = email;
        await api('/api/v1/staff/users/' + editingUser.id, { method: 'PATCH', body: JSON.stringify(body) });
        toast('✅ Usuario actualizado');
      } else {
        if (!username || username.length < 3) throw new Error('Usuario debe tener al menos 3 caracteres');
        if (!password || password.length < 6) throw new Error('Contraseña mínimo 6 caracteres');
        const body = { username, password, permissions };
        if (fullName) body.fullName = fullName;
        if (email) body.email = email;
        if (notes) body.notes = notes;
        await api('/api/v1/staff/users', { method: 'POST', body: JSON.stringify(body) });
        toast('✅ Usuario creado · entra en carlos-os1.duckdns.org/equipo/');
      }
      closeModal();
      loadUsers();
    } catch (e) {
      err.textContent = '❌ ' + e.message;
      err.style.display = 'block';
    }
  }

  document.getElementById('btn-new-staff').addEventListener('click', () => openModal());
  document.getElementById('modal-close').addEventListener('click', closeModal);
  document.getElementById('modal-cancel').addEventListener('click', closeModal);
  document.getElementById('modal-save').addEventListener('click', saveUser);
}
